import React from "react";
import {
  Grid,
  Typography,
  List,
  Divider,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import HelpMain from "./HelpMain";
import HelpTopic from "./HelpTopic";
import request from "../../../utilities/requests";

const Help = () => {
  const [topicId, setTopicId] = React.useState(null);

  if (topicId) {
    return <HelpTopic topicId={topicId} goBack={() => setTopicId(null)}/>
  }

  return <HelpMain setTopic={(id) => setTopicId(id)}/>


};

export default Help;
